import { LandingMediaDropbox } from './MediaDropBox';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { FeaturesSection as IFeaturesSection } from '@playbook-technologies/common-schemas/lib/catalog';

type Props = {
  imageUpload: (file: File) => Promise<string>;
  value: IFeaturesSection;
  onChange: (x: IFeaturesSection) => void;
};
export function FeaturesSection({ imageUpload, value, onChange }: Props) {
  function mergeState(x) {
    onChange({ ...value, ...x });
  }

  const landingPage = import.meta.env.VITE_LANDING_PAGE_URL;

  const features: {
    prop:
      | 'reminders'
      | 'streaks'
      | 'workouts'
      | 'favorites'
      | 'lifetime'
      | 'stream';
    name: string;
    image: string;
    desc: string;
  }[] = [
    {
      prop: 'reminders',
      name: 'Reminders',
      image: '/images/landing/features/reminders.png',
      desc: 'Set workout reminders to stay on track!',
    },
    {
      prop: 'streaks',
      name: 'Streaks',
      image: '/images/landing/features/streaks.png',
      desc: 'Complete at least one workout every week to get a streak!',
    },
    {
      prop: 'workouts',
      name: 'Video Workouts',
      image: '/images/landing/features/videos.png',
      desc: 'Easy-to-follow videos for every workout in the program.',
    },
    {
      prop: 'favorites',
      name: 'Favorites',
      image: '/images/landing/features/favorites.png',
      desc: 'Save your favorite workouts with the click of a button.',
    },
    {
      prop: 'lifetime', // NOTE: name is lifetime different due to mistake (copied from OTP)
      name: 'Notes & Logging',
      image: '/images/landing/features/notes.png',
      desc: 'Once you purchase, you own the program forever!',
    },
    {
      prop: 'stream',
      name: 'Stream Anywhere',
      image: '/images/landing/features/stream.png',
      desc: 'Stream to your TV and laptop using Airplay, Chromecast, Firestick and Cast2Web.',
    },
  ];

  return (
    <div className="">
      <div className="flex flex-wrap gap-10">
        {features.slice(0, 3).map((f) => {
          const coverImageProp: keyof IFeaturesSection = `${f.prop}CoverImage`;
          const defaultCover = landingPage + f.image;
          return (
            <LandingMediaDropbox
              key={f.prop}
              width="200px"
              height="408px"
              upload={imageUpload}
              label={f.name}
              validationText={f.desc}
              value={value[coverImageProp] || defaultCover}
              onChange={(coverImage) =>
                mergeState({ [coverImageProp]: coverImage })
              }
              type="image"
              icon={faImage as any}
            >
              <ul className="text-black list-none text-center text-h12">
                <li>Iphone resolution</li>
              </ul>
            </LandingMediaDropbox>
          );
        })}
      </div>

      <div className="mt-8 flex flex-wrap gap-10">
        {features.slice(3).map((f) => {
          const coverImageProp: keyof IFeaturesSection = `${f.prop}CoverImage`;
          const defaultCover = landingPage + f.image;
          return (
            <LandingMediaDropbox
              key={f.prop}
              width="200px"
              height="408px"
              upload={imageUpload}
              label={f.name}
              validationText={f.desc}
              value={value[coverImageProp] || defaultCover}
              onChange={(coverImage) =>
                mergeState({ [coverImageProp]: coverImage })
              }
              type="image"
              icon={faImage as any}
            >
              <ul className="text-black list-none text-center text-h12">
                <li>Iphone resolution</li>
              </ul>
            </LandingMediaDropbox>
          );
        })}
      </div>
    </div>
  );
}
